const uri = '/webapi/xm/1/person-property-definitions';

export const GET_PERSON_PROPERTY_DEFINITIONS = 'PERSON_PROPERTY_DEFINITIONS';
export const GET_PERSON_PROPERTY_DEFINITIONS_START = `${GET_PERSON_PROPERTY_DEFINITIONS}_START`;
export const GET_PERSON_PROPERTY_DEFINITIONS_SUCCESS = `${GET_PERSON_PROPERTY_DEFINITIONS}_SUCCESS`;
export const GET_PERSON_PROPERTY_DEFINITIONS_FAIL = `${GET_PERSON_PROPERTY_DEFINITIONS}_FAIL`;
export const getPersonPropertyDefinitions = (
  sortBy,
  sortOrder,
  actionType = GET_PERSON_PROPERTY_DEFINITIONS,
) => {
  const params = {
    ...(sortOrder && { sortOrder: sortOrder.toUpperCase() }),
    ...(sortBy && { sortBy: sortBy.toUpperCase() }),
  };

  return {
    type: actionType,
    meta: {
      xmApi: true,
      method: 'getall',
      uri,
      params,
    },
  };
};

export const GET_PERSON_PROPERTY_DEFINITIONS_DEFINED_ORDER =
  'PROPERTY_DEFINITIONS_DEFINED_ORDER';
export const GET_PERSON_PROPERTY_DEFINITIONS_DEFINED_ORDER_START = `${GET_PERSON_PROPERTY_DEFINITIONS_DEFINED_ORDER}_START`;
export const GET_PERSON_PROPERTY_DEFINITIONS_DEFINED_ORDER_SUCCESS = `${GET_PERSON_PROPERTY_DEFINITIONS_DEFINED_ORDER}_SUCCESS`;
export const GET_PERSON_PROPERTY_DEFINITIONS_DEFINED_ORDER_FAIL = `${GET_PERSON_PROPERTY_DEFINITIONS_DEFINED_ORDER}_FAIL`;

export const getPersonPropertyDefinitionsDefinedOrder = () =>
  getPersonPropertyDefinitions(
    'USER_DEFINED',
    'ASCENDING',
    GET_PERSON_PROPERTY_DEFINITIONS_DEFINED_ORDER,
  );
